module.exports = __webpack_public_path__ + "static/media/XXXIVe.c03216a5.png";